
export const modalDialog = {

    /* Modal Dialog System initialisation */
    modalDialogDefaultDialog:  undefined,
    modalDialogCaptureAll: false,
    openModals: [],

    init: function (id) {
        const modal = document.getElementById(id);
        modal.addEventListener('click', (event) => {
            modalDialifCloseOnBackdrop(event, id);
        });
    },

    openModal: function (id) {

        this.modalDialogDefaultDialog = id;

        if (!this.openModals.includes(id)) {
            this.openModals.push(id);
            if (!document.getElementById("dialog-backdrop")) {
                const backdrop = document.createElement('div');
                backdrop.id = "dialog-backdrop";
                document.body.classList.add('modal-open');
                document.body.insertBefore(backdrop, document.body.firstChild);
                backdrop.classList.add('modal-backdrop', 'fade');

                setTimeout(() => {
                    // Add the show class to the backdrop in this setTimeout
                    backdrop.classList.add('show');
                }, 1);
            }

            const modal = document.getElementById(id);
            modal.setAttribute('aria-hidden', 'false', 'show');
            modal.style.display = "block";
            modal.style.zIndex = 2000 + this.openModals.length;

            const inputTarget = document.querySelectorAll(`#${id} input, #${id} button, #${id} select`);
            this.addEventListenerList(inputTarget, "keypress", (event) => {
                if ((event.key === "Enter") && (this.modalDialogDefaultDialog !== undefined)) {
                    event.preventDefault();

                    // Trigger the button element with a click
                    const button = document.querySelector(`#${this.modalDialogDefaultDialog} .default-button`);
                    if (button) {
                        button.click();
                    }
                }
            });

            document.addEventListener("keypress", (event) => {
                // If the user presses the "Enter" key on the keyboard
                if (this.modalDialogCaptureAll && (event.key === "Enter") && (this.modalDialogDefaultDialog !== undefined)) {
                    // Cancel the default action, if needed
                    event.preventDefault();

                    // Trigger the button element with a click
                    const button = document.querySelector(`#${this.modalDialogDefaultDialog} .default-button`);
                    if (button) {
                        button.click();
                    }
                }
            });


            setTimeout(() => {
                // Move adding the show class to inside this setTimeout
                modal.classList.add('show');
            }, 1);
        }
    },
    closeModal: function (id) {
        let modalIndex = this.openModals.indexOf(id);
        if (modalIndex > -1) {
            this.openModals.splice(modalIndex, 1);

            if (this.modalDialogDefaultDialog == id) {
                this.modalDialogDefaultDialog = undefined;
            }

            if (this.openModals.length === 0) { // empty, so can remove the backdrop
                document.body.classList.remove('modal-open');
                const backdrop = document.querySelector('.modal-backdrop.fade');

                if (backdrop) { // might be gone
                    backdrop.classList.remove('show');
                    setTimeout(() => {
                        backdrop.remove();
                    }, 500);
                }
            }

            const modal = document.getElementById(id);
            if (modal) {
                modal.setAttribute('aria-hidden', 'true');
                modal.classList.remove('show');
            }

            closeTooltipsImpl();

            setTimeout(() => {
                if (modal) {
                    modal.style.display = 'none';
                }
            }, 500);
        }
    },

    addEventListenerList: function (list, eventName, fn) {
        for (var i = 0, len = list.length; i < len; i++) {
            list[i].addEventListener(eventName, fn, false);
        }
    },

    closeTooltips: function () {
        closeTooltipsImpl();
    }

}

function modalDialifCloseOnBackdrop(event, id) {
    if (event.target.classList.contains('modal-backdrop') || event.target.classList.contains('fade')) {
        modalDialog.closeModal(id);
    }
}

function closeTooltipsImpl() {
    const toolTips = document.getElementsByClassName("tooltip");
    for (let i = 0; i < toolTips.length; ++i) {
        toolTips[i].style.visibility = 'hidden';
    }
}
